<template>
<div class="chapter">
<div class="inner_page">
<h3 class="calibre3">Erster Akt</h3>
<p class="stage">Die Kapitelstube des Neumünsters zu Würzburg. In
der Hinterwand eine Bogentür nach der Kirche. Rechts Fenster mit
Nische. Im übrigen Chorstühle an den Wänden und ein langer leerer
Tisch, von Stühlen umgeben, in der Mitte des großen Raumes. Martin
ist beschäftigt, grüne Reiser anzunageln, welche Finkenmäuslin und
Kunzlin aus einem Korbe ihm zureichen. Am Tisch sitzt Lorenz
Löffelholz, ein nasses Tuch um den Kopf gewunden, und hat Schriften
vor sich aufgehäuft. In einer Fensternische der Rektor Besenmeyer
und Bezold, der Schultheiß von Ochsenfurt, die Vorgänge auf der
Straße durchs offene Fenster beobachtend. Stephan von Menzingen,
ein etwa vierzigjähriger Ritter in vollem Harnisch, sitzt
nachlässig in einem der Chorstühle.</p>
<p class="calibre1"><span class="speaker">Der Schultheiß</span>. Setzt Euch, Bruder
Rektor, Ihr seid müde!</p>
<p class="calibre1"><span class="speaker">Rektor Besenmeyer</span>. Schütt dich der
Ritt, Bruder Schultheiß! Necdum omnis hebet effoeto in corpore
sanguis: noch ist nicht alles Blut im alten Leibe vertrocknet. Was
denkt Ihr von mir? Wer ist dieser, der auf dem weißen Gaul?</p>
<p class="calibre1"><span class="speaker">Der Schultheiß</span>. Der Fettwanst, den
das Rößlein kaum tragen kann?</p>
<p class="calibre1"><span class="speaker">Löffelholz</span>. Wenn Ihr nit wißt, was
eine volle Sau ist, Bruder Rektor, so seht Euch den Jacob Kohl
an.</p>
<p class="calibre1"><span class="speaker">Rektor Besenmeyer</span>. Ist es der Jacob
Kohl? Sieht nit fast aus wie ein großer Kriegsmann.</p>
<p class="calibre1"><span class="speaker">Der Schultheiß</span>. Sind ihm auch
zuallererst die Federn ein wenig gewachsen; hat bis hieher
schwerlich wohl ein'n toten Mann gesehen gehabt.</p>
<p class="calibre1"><span class="speaker">Löffelholz</span>. Versteht er sich nit
auf Kriegshändel, so tuet er sich desto meh herfür, stehet mit dem
Maul und der Weinkannen in der Trinkstuben desto baß seinen Mann.
Höret doch zu, wie sie ihn anschreien! »Hans um und um« ist gar
wohlgelitten, wird aber dem Bischof sein Schloß wohl schwerlich ab
dem Berg stoßen.</p>
<p class="calibre1"><span class="speaker">Der Schultheiß</span>. Es war dann Sach,
daß es vor Dräuen umfiel – –</p>
<p class="calibre1"><span class="speaker">Menzingen</span>. Wird der Versammlungsrat
hie Sitzung halten?</p>
<p class="calibre1"><span class="speaker">Löffelholz</span>. Ja, Bruder, an alle
Hauptleut aller Haufen um Würzburg ist Ladung ergangen.</p>
<p class="calibre1"><span class="speaker">Menzingen</span>. Es tat not, daß wir uf
fürgebrachte Instruktion <a class="pcalibre pcalibre1 pcalibre3 pcalibre2" id="page21" title="r_a_5/gary"></a> und Handlung Bescheid erhielten, damit anheims zu
reiten gen Rothenburg.</p>
<p class="calibre1"><span class="speaker">Löffelholz</span>. Leid dich, Bruder
Menzingen: fasse dich mit der Geduld. – –</p>
<p class="calibre1"><span class="speaker">Martin</span>. Gib her, Finkenmäuslin!</p>
<p class="calibre1"><span class="speaker">Löffelholz</span>. Mach flugs, Martin! Du
mußt mit Schriften aufs Rathaus!</p>
<p class="calibre1"><span class="speaker">Martin</span>. Wohl, wohl, Bruder.
<span class="regie">Er singt.</span></p>
<p class="leftmarg">    Winter, du mußt Urlaub han,<br class="calibre2"/>
    das hab ich wohl vernommen.<br class="calibre2"/>
    Was mir der Winter hat angetan,<br class="calibre2"/>
    das klag ich diesem Sommer.</p>
<p class="leftmarg">Was machst du für ein Gesicht, Finkenmäuslin?
He, du, Kunzlin! Weißt nit, daß sich das Jubeljahr anfahet?</p>
<p class="calibre1"><span class="speaker">Kunzlin</span>. Ei freilich, Bruder!</p>
<p class="calibre1"><span class="speaker">Martin</span>. So mach einen Sprung und
schrei juhu!</p>
<p class="calibre1"><span class="speaker">Kunzlin</span> <span class="regie">springt
und schreit</span>. Juhu!</p>
<p class="calibre1"><span class="speaker">Martin</span>. Kotz Lung, wo ist mein
Hammer? Gib her!</p>
<p class="calibre1"><span class="speaker">Finkenmäuslin</span>. Ich hab ihn nit!</p>
<p class="calibre1"><span class="speaker">Martin</span>. Gib her!</p>
<p class="calibre1"><span class="speaker">Menzingen</span>. Er hat ihn nit. Hörst du
dann nit, du Partekenhengst?</p>
<p class="calibre1"><span class="speaker">Martin</span>. Wohlan, Bruder! ich hab oft
genung den Brotreigen vor der Bauern Türen mitsingen helfen. Itzt
singen die Bauern den Brotreigen vor den Schlössern und Häusern
ihrer Herrschaft. Aber einen so großmerklichen hab ich mein Tag nit
mitgesungen. Gib her den Hammer!</p>
<p class="calibre1"><span class="speaker">Finkenmäuslin</span>. Potz dieser und
jener, ich hab ihn nit.</p>
<p class="calibre1"><span class="speaker">Martin</span> <span class="regie">greift
in Finkenmäuslins Tasche und holt ihn heraus</span>. Jez, was ist
das? Bah!</p>
<p class="calibre1"><span class="speaker">Finkenmäuslin</span>. Wie ist das
zugangen?</p>
<p class="calibre1"><span class="speaker">Martin</span>. Wie ist das zugangen? Ja,
itzt ratet! Wofür hab ich Occams Schule genossen? Was wißt Ihr von
all meinen Subtilitäten? Zum Beispiel, Bruder Menzinger: kann Gott
sich mit der Kreatur vereinen oder nit? Gott kann sich mit der
Kreatur vereinen. Der Vater ist der Sohn der Jungfrau Maria. Der
Heilige Geist ist ein Mensch und der Sohn der Jungfrau. Der Vater,
der nie gestorben, hätte sterben können, und der Sohn, welcher
gestorben, hätte nie sterben können. Glaubt Ihr's nit? Euer Körper,
Bruder, kann intensiverweise an einem Orte unendlich weiß und
intensiverweise ins unendliche schwarz sein. Verstehet Ihr das,
oder nit? <a class="pcalibre pcalibre1 pcalibre3 pcalibre2" id="page22" title="r_a_5/gary"></a></p>
<p class="calibre1"><span class="speaker">Menzingen</span>, <span class="regie">lachend</span>. Gott helfe mir, nein, ich hab's nit
gelernet!</p>
<p class="calibre1"><span class="speaker">Rektor Besenmeyer</span>, <span class="regie">lachend</span>. So freuet Euch, denn Ihr brauchet nichts zu
verlernen. Hinderlich und elend ist uns unser Lernen. Wir haben
genung verdorbene Gehirne und Theologaster. Sie verstehen ihre
eigenen Bücher nit. Mit ihren exercitiis, copulatis, summis und
dergleichen labyrinthis ist nichts getan. Mit ihren Quästionen
werden sie die Hölle nit auslöschen, mit ihren Distinktionen den
Himmel nit aufschließen.</p>
<p class="calibre1"><span class="speaker">Der Schultheiß</span>. Bruder Rektor!</p>
<p class="calibre1"><span class="speaker">Rektor Besenmeyer</span>. Oha!</p>
<p class="calibre1"><span class="speaker">Der Schultheiß</span>. Kennt Ihr den
Berlinger von Angesicht?</p>
<p class="calibre1"><span class="speaker">Rektor Besenmeyer</span>. Den Götzen von
Berlichingen mit der eisernen Hand?</p>
<p class="calibre1"><span class="speaker">Der Schultheiß</span>. Der dort auf dem
magern Klepper sitzt.</p>
<p class="calibre1"><span class="speaker">Rektor Besenmeyer</span>. Das kurze
Männlein?</p>
<p class="calibre1"><span class="speaker">Der Schultheiß</span>. Das Nußknackerlein.
Mit dem er spricht, ist der Henneberger.</p>
<p class="calibre1"><span class="speaker">Menzingen</span>. Der Henneberger ist auch
in der Einung?</p>
<p class="calibre1"><span class="speaker">Löffelholz</span>. Die Henneberger sind in
der Einung, die Hohenlohe sind in der Einung, die Wertheims und
viele andre meh.</p>
<p class="calibre1"><span class="speaker">Rektor Besenmeyer</span>. Was disputieret
er doch wohl so eifrig?</p>
<p class="calibre1"><span class="speaker">Der Schultheiß</span>. Kotz Blau, was wird
es sein!? Die Geschichte vom Bamberger Bischof, mit dem er alleweil
in Händel gelegen.</p>
<p class="calibre1"><span class="speaker">Martin</span>. Wollt Ihr sie hören, Bruder
Rektor? Ich will sie Euch Wort für Wort aufsagen, und wann Ihr ein
alt Weib findet im Lande zu Franken, das sie nit herbetet wie das
Paternoster, so möget Ihr mich lassen mit einem Kürißbengel
totschlagen. – Es ist Sag, sie wollen den Berlinger zu eim Obersten
Hauptmann über uns alle setzen.</p>
<p class="calibre1"><span class="speaker">Löffelholz</span>. Das hat Hans Fürzlin
ersonnen. Der Götz ist nit viel meh dann ein hölzern Schüreisen und
als ein Gefangener im eigenen Haufen. Er darf nit seine Notdurft
verrichten, es ist einer dabei, der ihm aufpaßt. Was soll er
ausrichten, wenn man ihn wollte zum Herrn machen über
dreißigtausend wütige Leut?!</p>
<p class="calibre1"><span class="speaker">Der Schultheiß</span>. Hat kein Marks in
den Händen, der ganze Götz.</p>
<p class="calibre1"><span class="speaker">Menzingen</span>. Wo liegt der
evangelische Hauf, Bruder?</p>
<p class="calibre1"><span class="speaker">Löffelholz</span>. Zu Hugberg und
Randersacker. <a class="pcalibre pcalibre1 pcalibre3 pcalibre2" id="page23" title="Teledahner/gary"></a></p>
<p class="calibre1"><span class="speaker">Rektor Besenmeyer</span>. Wieviel schätzet
Ihr itzt Bäurische in und um Würzburg?</p>
<p class="calibre1"><span class="speaker">Der Schultheiß</span>. Potz Leichnam, sie
könnten den Main aussaufen!</p>
<p class="calibre1"><span class="speaker">Menzingen</span>. Meinet Ihr, daß sie sich
in der Besatzung ernstlich werden zur Wehre schicken und
unterstehen, das Schloß zu halten wider die Übermacht?</p>
<p class="calibre1"><span class="speaker">Der Schultheiß</span>. Es ist eine tapfre
Anzahl guter, gedienter Leut in der Burg.</p>
<p class="calibre1"><span class="speaker">Löffelholz</span>, <span class="regie">zu
Menzingen.</span> Mauerbrechend Geschütz, Bruder, als ihr zu
Rothenburg habt; es fehlt uns an guten Stücken; schafft uns eure
zwo Notschlangen herbei. Ist Bresche gemacht, so lasset Gott und
den Florian Geyer für das andre sorgen.</p>
<p class="calibre1"><span class="speaker">Martin</span>. Bruder, der Florian Geyer
verstehet sich auf Kriegshändel meh dann die übrigen Hauptleut samt
und sunders, und seine Schwarzen richten meh aus dann alle andern
Haufen der Bauernschaft. Wer den Geyer und seine Schwarzen bei
Weinsberg gesehn hat, der weiß, daß ich vor Gott red und die lautre
Wahrheit.</p>
<p class="calibre1"><span class="speaker">Löffelholz</span>. Ich stund auch dabei,
als sie den Sturm antraten . . . Ihr wißt, daß, inwährend wir mit
dem Helfensteiner in Handlung stunden, er uns ließ
hochverräterischerweis seine Reuter im Rücken abbrechen mit Stechen
und Brennen. Alsbald es ruchbar ward in den Lägern, war jedermanns
Meinung darauf, daß man sollte mit dem Ernst herfür und stürmen
gesamter Hand. Zuvor aber waren sie Herolde senden, aber die schoß
man uns darnieder wider Kriegsbrauch und Recht. Kam einer von den
Geschickten blutig und mit Geschrei daher, und nu war kein Halten,
rennete alles wider die Stadtmauer. Itzt trat der Florian Geyer zu
seinen Schwarzen und schrie sie an: »In einer halben Stunde sind
wir tot, Brüder, oder die schwarze Fahne steckt uf'm Schloßturm.«
Was sag ich, Brüder, es sind nit meh dann viertausend Kerls; aber
wenn sie die Erde über den Kopf geworfen haben und her! her!
schreien, so wollt ich dem Teufel lieber begegnen. So risch dir
drei Rosen am Paternoster durch deine Finger mögen gleiten,
alsobald brachen sie in die Weinberge, stäubten den Berg hinauf,
hingen an der Mauer und sprangen darüber wie Katzen, wurfen alles
nieder und ließen die Bauernfahne von allen Türmen wehn.
<span class="regie">Wilhelm von Grumbach tritt ein,</span> <a class="pcalibre pcalibre1 pcalibre3 pcalibre2" id="page24" title="suru/gary"></a> <span class="regie">prachtvoll geharnischt.</span> Dawider nehmet den
Berlinger, der will den Fuchs nindert nit beißen. Ihm sind alle
Fuhrten und Gräben zu tief und die Moräste zu breit, den setze der
Teufel über sich.</p>
<p class="calibre1"><span class="speaker">Der Schultheiß</span>. Walt's Gott, wir
erwählen den rechten Mann.</p>
<p class="calibre1"><span class="speaker">Martin</span>. Hoch Florian Geyer! Sieger
von Weinsberg! Der Geyer soll unser Hauptmann sein!</p>
<p class="calibre1"><span class="speaker">Löffelholz</span>. Sie denken nit alle so
wie wir.</p>
<p class="calibre1"><span class="speaker">Wilhelm von Grumbach</span>. Ich wünsch
euch gute Zeit, ihr Herren!</p>
<p class="calibre1"><span class="speaker">Löffelholz</span>. Es ist aus und hin mit
der Herrlichkeit; hie sind keine Herrn. Was willst du, Bruder?</p>
<p class="calibre1"><span class="speaker">Wilhelm von Grumbach</span>. Des Junkers
Florian von Geyer Feldschreiber such ich.</p>
<p class="calibre1"><span class="speaker">Löffelholz</span>. So wirst du ihn
ebensowenig finden, als wenn du ausgegangen wärst, des Teufels
Feldschreiber zu suchen.</p>
<p class="calibre1"><span class="speaker">Wilhelm von Grumbach</span>. Kotz Schweiß,
wo find ich den Lorenz Löffelholz?</p>
<p class="calibre1"><span class="speaker">Löffelholz</span>. Kotz, ich bin der
Lorenz Löffelholz, aber niemals nit eines Edelmanns Feldschreiber.
Meinest du, ich sollt sitzen und mich brauchen lassen – Gott weiß
es, daß ich meh tot dann lebendig bin! –, so es im
Herrendienst wäre?</p>
<p class="calibre1"><span class="speaker">Menzingen</span>. Gott grüß dich,
Wilhelm!</p>
<p class="calibre1"><span class="speaker">Wilhelm von Grumbach</span>. Gott dank
dir, Stephan!</p>
<p class="calibre1"><span class="speaker">Menzingen</span>, <span class="regie">zu
Löffelholz</span>. Es ist der Junker von Grumbach, Bruder, dessen
Schwester der Florian Geyer zur Eh hat.</p>
<p class="calibre1"><span class="speaker">Löffelholz</span>. Das schiert mich den
Teufel. Was willst du, Bruder?</p>
<p class="calibre1"><span class="speaker">Wilhelm von Grumbach</span>. Es ist mir im
Läger zu Heidingsfeld ein Schutz- und Sicherheitsbrief
zugesagt.</p>
<p class="calibre1"><span class="speaker">Löffelholz</span>. Dacht ich's doch
gleich! Ein armer Ritter, der einen Schutzbrief erbettelt.</p>
<p class="calibre1"><span class="speaker">Wilhelm von Grumbach</span>, <span class="regie">jähzornig</span>. Itzt, Schreiber, gib acht, wer vor dir
steht.</p>
<p class="calibre1"><span class="speaker">Löffelholz</span>. Willst du vom Leder
zucken!? Ich weiß, daß du ein Wehr hast. Ich weiß auch, wer vor mir
steht: ein Bruder Bauer stehet vor mir! Wie heißt du, Bruder?</p>
<p class="calibre1"><span class="speaker">Wilhelm von Grumbach</span>. Ich bin der
Ritter Wilhelm von Grumbach.</p>
<p class="calibre1"><span class="speaker">Löffelholz</span>. Streich dein Wappen
aus, Bruder. Es hat kein <a class="pcalibre pcalibre1 pcalibre3 pcalibre2" id="page25" title="suru/gary"></a> Art meh damit. Du wirst ein Bauer so gut wie ich,
dawider kann dir kein Schutzbrief nit helfen. <span class="regie">Grumbach nimmt den Schutzbrief, der ihm hingeworfen wird
wie dem Hunde der Brocken, und unterdrückt seine Wut. Er tritt zu
Menzingen in eine Nische und redet leise mit ihm.</span> Ist nichts
dann Fliehen und Flehen in der Ritterschaft. Denken an nichts
anders, dann daß sie ihre festen Häuser und Äcker erretten wollen.
Da sehet den Florian Geyer an, der schonet des Seinen in keinem
Weg. Haben ihm itzt die Stammburg mit Feuer niedergelegt, hat aber
nit mit der Wimper gezuckt.</p>
<p class="calibre1"><span class="speaker">Der Schultheiß</span>, <span class="regie">leise zu Löffelholz.</span> Ich hab gemeint, der Grumbach
wär in der Besatzung.</p>
<p class="calibre1"><span class="speaker">Löffelholz</span>. Ei, wär es so, ich
vergunnt es dem Bischof; es ist nichts gelegen an solcher
Bruderschaft. Es ist ihnen nit ums göttliche Recht. Sie suchen
ihren Vorteil, wie die Raben nach Aas fliegen.</p>
<p class="stage">Glocken beginnen zu läuten.</p>
<p class="calibre1"><span class="speaker">Martin</span>, <span class="regie">an der
Tür nach der Kirche.</span> Brüder, die Kirche ist ganz voll
Menschen, stehen Kopf an Kopf.</p>
<p class="calibre1"><span class="speaker">Rektor Besenmeyer</span>. Sagtet Ihr nit,
der Pater Ambrosius werde predigen?</p>
<p class="calibre1"><span class="speaker">Der Schultheiß</span>. Ja, Bruder
Rektor!</p>
<p class="calibre1"><span class="speaker">Rektor Besenmeyer</span>. Es ist wahrlich
ein großer Tag, und nun ich ihn gesehen hab, will ich gern und
getrost dahinfahren.</p>
<p class="calibre1"><span class="speaker">Löffelholz</span>. Mere, liebe Brüder, das
Glück schneiet mit großen Flocken und ist, Gott! Wunders genug. Es
ist sichtbarlich und mit Händen zu greifen; Gott hat sich in den
Handel geschlagen und sich der armen teutschen Nation erbarmt.</p>
<p class="calibre1"><span class="speaker">Rektor Besenmeyer</span>. Es ist Sag: von
wo unser Herr Jesus ist aufgefahren gen Himmel, im Mittelpunkt der
Erden, da, heißt es, hangt eine große Glocke, die soll einst laut
und fürchterlich anschlagen, so laut und so fürchterlich soll sie
anschlagen, daß selbst die Tauben sie hören werden. Wohlan!
knäufelt die Ohren auf, ihr Tyrannen und Peiniger Leibes und der
Seele, und merket, daß euer Jüngster Tag nahet.</p>
<p class="stage">Bubenleben kommt.</p>
<p class="calibre1"><span class="speaker">Martin</span>, <span class="regie">triumphierend.</span> Hörst du das Geschrei, Bruder
Bubenleben? Der Florian Geyer reitet ein. <a class="pcalibre pcalibre1 pcalibre3 pcalibre2" id="page26" title="lac/gary"></a></p>
<p class="calibre1"><span class="speaker">Löffelholz</span>. Bruder Bubenleben, ich
verhoff, daß Gott Euch itzt wird die Augen auftun und Euch zeigen,
wen er sich in diesen Läuften zu seim Helden gemacht.</p>
<p class="calibre1"><span class="speaker">Bubenleben</span> <span class="regie">legt
eine Druckschrift vor Löffelholz.</span> Da, leset: An die
Versammlung der Bauernschaft deutscher Nation, ausgangen von
oberländischen Mitbrüdern. Hie stehet geschrieben die gleiche
Meinung, uf der ich verharre: die Anführer sollen Bauern sein,
unsresgleichen. Nimmt man einen von Adel darein, verschleicht man
Wolfshaar unter die Schafwollen. Das kann sich nit reimen, liebe
Brüder!</p>
<p class="calibre1"><span class="speaker">Martin</span>, <span class="regie">in
Begeisterungsraserei am Fenster.</span> Vivat der schwarz
Geyer!</p>
<p class="calibre1"><span class="speaker">Rektor Besenmeyer</span>, <span class="regie">außer sich.</span> Vivat St. Georg! Vivat
St. Georg!</p>
<p class="calibre1"><span class="speaker">Löffelholz</span>. Sitzt er nit auf dem
Gaul so richt und strack als ein Bolz?</p>
<p class="calibre1"><span class="speaker">Rektor Besenmeyer</span>. Wahrlich ein
echter, rechter Gotteshauptmann!</p>
<p class="calibre1"><span class="speaker">Der Schultheiß</span>. Hat Rost am
Harnisch, aber nit am Schwert!</p>
<p class="calibre1"><span class="speaker">Rektor Besenmeyer</span>. Ein brennendes
Recht fließt durch sein Herz.</p>
<p class="calibre1"><span class="speaker">Martin</span>. Vivat der schwarze Geyer!
Vivat Florian Geyer! <span class="regie">Er rennt nach der Tür zur
Kirche.</span> Er ist in die Kirche getreten.</p>
<p class="calibre1"><span class="speaker">Rektor Besenmeyer</span>. Mit allen
Trabanten.</p>
<p class="calibre1"><span class="speaker">Martin</span>. Sind an hundert Trabanten
mit ihm im vollen Harnisch.</p>
<p class="stage">Löffelholz und der Schultheiß flüstern
miteinander.</p>
<p class="calibre1"><span class="speaker">Bubenleben</span>. Da verspür ich wohl
höllische Tyrannei, aber nichts nit von christlicher Demut.</p>
<p class="stage">Tellermann, geharnischt, kommt herein in einem
Freudenrausch von Wein- und Einzugsbegeisterung.</p>
<p class="calibre1"><span class="speaker">Tellermann</span> <span class="regie">steht, schwingt das Schwert hoch.</span> Grüß euch Gott,
liebe Brüder, segne euch Gott, liebe evangelische Brüder! Morbleu,
liebe Brüder. J'ay gaigné mon procès. Entendez-vous? Der große Tag
ist da! Écutez, écutez! Sehet mich nit darauf an, was ich red, wie
ich red. Der Wein ist mir in'n Kopf krochen. Das Glück ist mir ins
Herz krochen. Brüder, – <span class="regie">mit den Fäusten auf den
Tisch trommelnd</span> – itzt bin ich daheim – und wie sind wir
eingeritten! Mort de ma vie, Pfaff! Itzt sind wir daheim! Wo <a class="pcalibre pcalibre1 pcalibre3 pcalibre2" id="page27" title="suru/gary"></a> aber bist du,
Bischöflein? Hast davongemußt, dich flüchten aus deinem Pracht.
Bugre! larron! menteur! fils de putain! traître! faquin! brutal!
bourreau! Hast uns verjagt und vertrieben wie schlechte Hunde.
Outrage pour outrage!</p>
<p class="calibre1"><span class="speaker">Der Schultheiß</span>. Wie sieht's aus uf
der Gassen, Bruder?</p>
<p class="calibre1"><span class="speaker">Tellermann</span>, <span class="regie">den
Schultheiß umarmend.</span> Brüderlein, liebes Schultheißlein, es
ist meh des Segens, dann einer kann im Busen behalten. Gott, Gott!
Was eine glückselige Widerfahrt! Je Jene, je Jene. Juch! Der
Florian Geyer soll leben! Oberster Feldhauptmann über alle Haufen.
Ein Hundsfott, der nit Bescheid tut!</p>
<p class="calibre1"><span class="speaker">Der Schultheiß</span>. Walt's Gott! Ich tu
dir Bescheid!</p>
<p class="calibre1"><span class="speaker">Tellermann</span>. Morbleu! Wie haben sie
ihn geehrt! Am Hauger Tor hat er still gehalten. Ist wie alle Tore
sperrangelweit ufgewest. Hat aber dannoch dawider gebocht mit dem
Schwertknauf und hinaufgeschrien gen den Frauenberg. »Hie kehre ich
heim, Florian Geyer, in Kaisers Acht und Papstes Bann, aber von
Gott erweckt, erwählet und geführet! Hie kehre ich heim, Florian
Geyer, des Sickingen Freund und der Pfaffen Feind, wie ich bei mir
selbst gelobt und geschworen, und will nit rasten, bis daß ich dein
hochstolz Schloß, du hochstolzer, teuflischer Pfaffe Konrad, in
Grund verstört.« So hat er geschrien, so sind wir einritten. War
des Jubeljauchzens kein Ende; wehten mit Tüchern aus allen
Fenstern. Die Weiber wollten gar auf die Straßen springen vor
Jauchzen und Lust; sein Gaul konnte kaum fortschreiten. Sie küßten
ihm den Stegreif und leckten ihm den Rost vom Harnisch. Waren
dieselben Plätze und Straßen, wo römisch-kaiserliche Majestät offne
Acht über uns ausblasen, verrufen und ausschreien lassen.
<span class="regie">Mit Beziehung auf Bubenleben.</span> Was will
der Pfaff hier? Alle in einen Sack und unter die Schindbrücke mit
ihnen!</p>
<p class="calibre1"><span class="speaker">Der Schultheiß</span>. Sei ruhig, Bruder,
fasse dich, Bruder!</p>
<p class="stage">Ein Domherr, der Schreiberdienste tut, kommt.</p>
<p class="calibre1"><span class="speaker">Tellermann</span>. Kotz Blut, kenn ich
dich nit, bist du nit ein verfluchter Domherr vordem gewest? Mort
de ma vie! Hat nit der Sendpfaff mit dir zu Morgen gessen, nachdem
er den Stab gebrochen über meine Mutter selig?</p>
<p class="calibre1"><span class="speaker">Domherr</span>. Ach Lieber, mein Herr, Ihr
irret Euch wahrlich!</p>
<p class="calibre1"><span class="speaker">Tellermann</span>. Hast du nit Scheiter
herbeigeschleppt und Öl, Pech und Schwefel daraufgossen, als man
sie verbrannt <a class="pcalibre pcalibre1 pcalibre3 pcalibre2" id="page28" title="suru/gary"></a>
auf dem Jüdenplatz? Da, hier, schau mich an! Ich bin der
Tellermann, ich bin ein Begard, ich bin ein Kunde, ich bin ein
heimlicher Ketzer. Meine Mutter selig wollt's nit gestehn, man hat
sie aufgezogen eine Hand hoch, so lang man drei Paternoster
spricht. Sie hat's nit gestanden, Gott verzeih ihr's. Ich aber
bekenn freiwillig: ich hab allezeit das Evangelium liebgehabt, meh
dann Menschentand. Ich leugne nit: ich gehör zu den freien
Geistern. Frei sind wir, weil Gott uns befreit hat und unsre
Bedrücker, Feinde und Seelenmörder zerstreuet wie Mehl. Frei sind
wir, weil wir kein Gewissen nit haben und von diesem bösen Tier nit
zerfetzet und zerrissen werden. Und, Pfaffe, so hindert mich
nichts, daß ich dich niederschlag . . .</p>
<p class="calibre1"><span class="speaker">Der Schultheiß</span>. Friede! Friede!</p>
<p class="calibre1"><span class="speaker">Tellermann</span>, <span class="regie">vom
Schultheiß und den andern gehalten und verhindert, in Raserei,
schreit.</span> Schlagt tot! Schlagt tot! <span class="regie">Der
Domherr flüchtet sich, und Tellermann sinkt, erschöpft und nahezu
besinnungslos, auf einen Stuhl.</span></p>
<p class="calibre1"><span class="speaker">Der Schultheiß</span>. Es ist der
Tellermann, eines Roßhändlers Sohn. Haben ihm vor zehn Jahren hie
zu Würzburg die Mutter verbrannt. Da hat es ihn itzunder übermannt,
ansonsten kein besserer Kriegsmann im ganzen hellen Haufen dann er.
Der Geyer und er sind eine Hand.</p>
<p class="calibre1"><span class="speaker">Rektor Besenmeyer</span>. Ein rasender
Ajax, Brüder!</p>
<p class="calibre1"><span class="speaker">Der Schultheiß</span>. Hunderte für einen
allenthalben im Volk!</p>
<p class="calibre1"><span class="speaker">Rektor Besenmeyer</span>.
Gottesgeißeln!</p>
<p class="calibre1"><span class="speaker">Der Schultheiß</span>. Saat von
Drachenzähnen, ausgesäet von Papst, Kardinälen, Bischöfen und
Meßpfaffen, aufgangen ihnen selbst zum Verderben.</p>
<p class="calibre1"><span class="speaker">Rektor Besenmeyer</span>. Schweig stille,
der Pater Ambrosius spricht! <span class="regie">Man hört aus der
Kirche den Tonfall einer Predigt, ohne Worte zu
verstehen.</span></p>
<p class="stage">Durch die Nebentür links treten auf Sebastian von
Rotenhahn, Wolf von Kastell, Hans von Lichtenstein, Hans von
Grumbach, Kunz von der Mühlen. Sie werden geführt von
Sartorius.</p>
<p class="calibre1"><span class="speaker">Sartorius</span>, <span class="regie">mit
Gravität zu Löffelholz tretend, der, im Anhören der Predigt
begriffen, sein Herankommen nicht bemerkt hat.</span> Ihr werdet
mir verzeihen . . . Ich habe die Legation hergeführt, Euer
Hochgelahrt.</p>
<p class="calibre1"><span class="speaker">Löffelholz</span>. Zu früh, Bruder.</p>
<p class="calibre1"><span class="speaker">Sartorius</span>. Ich bin von Wendel
Hipplern auf diese Stunde befohlen, Euer Hochgelahrt. <a class="pcalibre pcalibre1 pcalibre3 pcalibre2" id="page29" title="r_a_5/quilter"></a></p>
<p class="calibre1"><span class="speaker">Löffelholz</span>. Ei, nennet mich doch
nicht Hochgelahrt, Bruder. Wir sind allzumal Sünder und mangeln des
Ruhms.</p>
<p class="calibre1"><span class="speaker">Sartorius</span>. Mere, lieber Bruder, Ihr
habt recht.</p>
<p class="stage">Sie fahren fort, leise miteinander zu sprechen.
Derweil hat die Gruppe der Gesandtschaft untereinander geflüstert.
Wilhelm von Grumbach hat eine Wendung gemacht und sie bemerkt. Er
stößt Menzingen an, und beide blicken sich um. Möglichst
unauffällig treten beide der Gesandtschaftsgruppe näher.</p>
<p class="calibre1"><span class="speaker">Sebastian von Rotenhahn</span>,
<span class="regie">gepreßt</span>. Bei der Liebe Gottes! seid ihr
zu schwarzen Bauern worden?</p>
<p class="calibre1"><span class="speaker">Wilhelm von Grumbach</span>. Ich bin in
des Markgrafen zu Ansbach Diensten hie.</p>
<p class="calibre1"><span class="speaker">Sebastian von Rotenhahn</span>. Hast aber
doch das bäurische Kreuz am Arm.</p>
<p class="calibre1"><span class="speaker">Wilhelm von Grumbach</span>. Muß wohl, es
sei mir lieb oder leid. Ist ohn das nit durchzukommen.</p>
<p class="calibre1"><span class="speaker">Sebastian von Rotenhahn</span>. Junker von
Menzingen? Wo hat Euch der Teufel hergetragen?</p>
<p class="calibre1"><span class="speaker">Menzingen</span>. Ich bin in der Legation
von Rothenburg.</p>
<p class="calibre1"><span class="speaker">Sebastian von Rotenhahn</span>. Seid Ihr
dann zu Rothenburg Bürger worden?</p>
<p class="calibre1"><span class="speaker">Menzingen</span>. Ei freilich, Junker!
Wußtet Ihr das noch nit?</p>
<p class="calibre1"><span class="speaker">Sebastian von Rotenhahn</span>. Wußt ich
es schon nit, so begreif ich es dennoch zu wohl, daß Ihr hinter den
Mauern der Reichsstädte Schutz suchet.</p>
<p class="calibre1"><span class="speaker">Menzingen</span>. Ihr beliebet zu
scherzen, Ritter!</p>
<p class="calibre1"><span class="speaker">Sebastian von Rotenhahn</span>. Hat nicht
Euer Name auch unter der Absag gestanden, die der Landes
Vertriebene Ulrich von Württemberg gen Stuttgart getan, bevor ihn
der Helfensteiner so böslich und meisterlich hat heimgehen
heißen?</p>
<p class="calibre1"><span class="speaker">Menzingen</span>. Der Handel ist nit zu
Ende, Ritter! Ist darnach dem Helfensteiner übel bekommen. Hat
müssen zu Weinsberg sein Leben lassen.</p>
<p class="calibre1"><span class="speaker">Sebastian von Rotenhahn</span>. Je, saget
Ihr das!? – So spricht dann die Red wahr, die unter dem Volke
gehet: der König von Frankreich und der verlorne Fürst hätten die
Karten gemischt, der Geyer hätt sie zu Hohentwiel vom Tische
genommen und ausgeben: und also das große bäurische Spiel
angehoben!?</p>
<p class="calibre1"><span class="speaker">Menzingen</span>. Da fraget Ihr nach!?</p>
<p class="calibre1"><span class="speaker">Sebastian von Rotenhahn</span>. So wird
man ein jedes Tröpflein <a class="pcalibre pcalibre1 pcalibre3 pcalibre2" id="page30" title="r_a_5/gary"></a> adligen Bluts, zu Weinsberg vergossen, dereinst
von Euch fordern. <span class="regie">Menzingen wendet sich mit
Achselzucken.</span></p>
<p class="calibre1"><span class="speaker">Lichtenstein</span>. Will die hochstolze
reichsfreie Stadt sich auch mit dem Unrat vermengen und sich in die
höllische Einung tun?</p>
<p class="calibre1"><span class="speaker">Menzingen</span>. Das wird geschehen, wie
Gott es fügt, Ritter.</p>
<p class="calibre1"><span class="speaker">Hans von Grumbach</span>, <span class="regie">zu Wilhelm</span>. Kotz Leichnam, Vetter, sollen wir einer
dem andern Feind sein? Wie reimet sich das?</p>
<p class="calibre1"><span class="speaker">Wilhelm von Grumbach</span>. Blau, Hans!
Da siehe du zu!</p>
<p class="calibre1"><span class="speaker">Wolf von Kastell</span>. Hat dich der
Bischof nit ufgemahnet, dich in die Besatzung zu tun?</p>
<p class="calibre1"><span class="speaker">Wilhelm von Grumbach</span>. Ich bin dem
Markgrafen zu Ansbach mit Diensten verbunden und für ihn zu reiten
und reisen verpflicht.</p>
<p class="calibre1"><span class="speaker">Lichtenstein</span>. Der Junker von
Grumbach hat es niemalen anders gehalten: wann er die Klepper im
Dienste des Markgrafen abgetrieben, so stunden sie bald danach am
Hof unsers Bischofs in Habern bis an den Hals.</p>
<p class="calibre1"><span class="speaker">Wilhelm von Grumbach</span>. Kotz Bauch,
dafür hab ich nit meh dann fünfhundert Schweine im Gramschatz und
der Bischof ihrer zweitausend auf Eichelmast, und ist doch mein
Wald. Dafür schießen seine Domherrn und Diener das Wild in meinem
Forst und fischen in meinen Bächen.</p>
<p class="calibre1"><span class="speaker">Wolf von Kastell</span>. Bist du unbillig
beschweret, so hast du den Weg Rechtens.</p>
<p class="calibre1"><span class="speaker">Wilhelm von Grumbach</span>. Die Pfaffen
tun mit Liebe nichts, man ziehe ihnen dann das Fell über die
Ohren.</p>
<p class="calibre1"><span class="speaker">Wolf von Kastell</span>. Bist du nit
schuldig, dem Bischof zuzuziehn?</p>
<p class="calibre1"><span class="speaker">Wilhelm von Grumbach</span>. Leichnam! So
hat der Pfaff wahrlich gut Riemen schneiden, wenn die reichsfreie
Ritterschaft ihre Haut also billig und knechtswillig zu Markte
bringt. Ich bin nit schuldig, dem Bischof in eigner Person
zuzuziehn! ist wider Herkommen fränkischen Adels.</p>
<p class="calibre1"><span class="speaker">Hans von Grumbach</span>. Hast du nit
deine Güter vom Stift zu Lehen?</p>
<p class="calibre1"><span class="speaker">Wilhelm von Grumbach</span>. Unsere Lehne
sind nit Gnaden- und Dienstlehne, sondern freie Lehne.</p>
<p class="calibre1"><span class="speaker">Wolf von Kastell,</span> <span class="regie">zu Sartorius, der herantritt.</span> Ist wohl Eure
Weisheit, Herr Magister?</p>
<p class="calibre1"><span class="speaker">Sartorius</span>. Ich fürchte Gott und
liebe meinen Herrn, Euer <a class="pcalibre pcalibre1 pcalibre3 pcalibre2" id="page31" title="r_a_5/gary"></a> Edel. Ich diene Seiner Gestrengen mit meinem
Paternoster und guten Rat, solange es Gott und meinem gnädigen
Herrn gefällt.</p>
<p class="calibre1"><span class="speaker">Wilhelm von Grumbach</span>. Brav gered't,
Meister!</p>
<p class="calibre1"><span class="speaker">Wolf von Kastell</span>. Die Juristen und
Räte, das ist die Pest; treiben ihre Herren in Unrat und Verderben.
Hole der Teufel alle roten Schuhe!</p>
<p class="calibre1"><span class="speaker">Menzingen</span>. So seht doch zuallererst
euren Bischof an! Der ist mit Juristen behängt wie ein Jakobsbruder
mit Muscheln.</p>
<p class="calibre1"><span class="speaker">Sebastian von Rotenhahn</span>,
<span class="regie">zu Sartorius</span>. Das Üble bei dem Handel
ist: Ihr kommet um Eure Verehrung, Magister.</p>
<p class="calibre1"><span class="speaker">Sartorius</span>. Das soll mich nit
kränken, Euer Hochgelahrt!</p>
<p class="calibre1"><span class="speaker">Sebastian von Rotenhahn</span>. Entlaufet
Ihr schon des Bischofs Nachrichter, so zieht man Euch desto
sicherer an dem bäurischen Galgen auf.</p>
<p class="calibre1"><span class="speaker">Sartorius</span>. Steht zu bedenken, Euer
Edlen. Ich tue das Gute nit um schnöder Handsalben willen, Euer
Hochgelahrt; und vermeide das Rechte nit aus niederer Furcht.</p>
<p class="calibre1"><span class="speaker">Lichtenstein</span>. Das Kurze und Lange
ist: der Junker von Grumbach verrät seinen Lehnsherrn.</p>
<p class="calibre1"><span class="speaker">Wilhelm von Grumbach</span>. Der Kaiser
ist mein Lehnsherr und kein Pfaffe zu Würzburg; ich bin kein
Pfaffenknecht.</p>
<p class="calibre1"><span class="speaker">Sebastian von Rotenhahn</span>. Das ist
itzt der Ton, danach alle singen. Wer itzt das Rechte will und das
Gute tut, der heißt ein Pfaffenknecht.</p>
<p class="calibre1"><span class="speaker">Wilhelm von Grumbach</span>. Kotz Dreck,
itzt auf einmal, itzt war ich dem Bischof gut genung, itzt soll ich
ihm seine Schmalzgruben und den Domherren ihre seidenen Betten und
ihren Wollust verteidigen. Das tue der Teufel!</p>
<p class="calibre1"><span class="speaker">Löffelholz</span>. Was reden die Ritter
untereinander?</p>
<p class="calibre1"><span class="speaker">Sartorius</span>. Ihr Herren, tretet
zurück, folget mir! Wir sind zu früh kommen.</p>
<p class="calibre1"><span class="speaker">Wolf von Kastell</span>. Kotz Blau, ich
möcht mit der Wehre dreinschlagen.</p>
<p class="stage">Von Sartorius geleitet, ziehen sie sich
zurück.</p>
<p class="calibre1"><span class="speaker">Rektor Besenmeyer</span>, <span class="regie">immer noch der Predigt zuhörend</span>. Der Pater Ambrosius
schließt die Predigt in Latein. Er weiset die Brüder und Schwestern
auf Wiclefs evangelischen Zukunftsstaat. Tunc necessitaretur
respublica redire ad politiam evangelicam, habens omnia in
communi . . . Brav, Bruder, in deiner Predigt war Gottestreiben. Du
hast <a class="pcalibre pcalibre1 pcalibre3 pcalibre2" id="page32" title="r_a_5/gary"></a> wahrlich
nit von blauen Enten und von Hühnermilch gered't! War ein ander
Ding als damalen, zu Erfurt in der Burs, als ich Kollegiat war und
täglich eine Rede über die Jungfrau hinunterschlucken mußte.</p>
<p class="stage">Die Gemeine singt in der Kirche. Zu Beginn des
Gesanges ist Tellermann auf beide Füße gesprungen. Regellos und
gruppenweise betreten jetzt bäurische Hauptleute und Räte von der
Kirche aus die Kapitelstube. Sie flüstern und reden lebhaft
miteinander, ohne daß man etwas versteht. Die Ritter werden bemerkt
und mißtrauisch betrachtet. Unter den Hereingekommenen ist Wendel
Hippler, welcher sogleich lebhaft mit Löffelholz disputiert und
gestikuliert. Er wird von den meisten äußerst respektvoll
behandelt. Sartorius, wieder hereingekommen, bemüht sich
ehrfurchtsvoll um ihn. Der dicke Jacob Kohl ist auch zugegen. Er
ist sogleich mit Bubenleben ins Gespräch geraten. Man erkennt, wie
sie unzufrieden, ja über irgend etwas entrüstet sind. Eine
gelbschwarze Fahne und eine weiß-damastene werden hereingetragen;
auf der einen ist mit Goldfäden eine Sonne und ein Bundschuh
gestickt, dazu die Inschrift: »Wer da frei will sein, der zieh in
diesen Sonnenschein.« Götz von Berlichingen, der kaum andere als
hämische Beachtung findet, tritt ein im Gespräch mit Georg Metzler.
Sie nähern sich Hippler und bilden im Verein mit diesem und
Sartorius eine Gruppe. Götz erscheint unwirsch und ablehnend.
Wilhelm von Grumbach gliedert sich an diese Gruppe und begrüßt sich
mit Götz und dem Grafen Georg von Wertheim, der sich auch
angefunden hat. Flammenbecker, ein Weinsberger, gestikuliert wild
unter Genossen. Link, ein Würzburger Bürger, hat auch eine kleine
Gemeine um sich gebildet. In der Gesamtheit verrät sich bei allem
Hochgefühl eine Besorgnis, Erregung, ja Spannung.</p>
<p class="stage">Florian Geyer, schwarz geharnischt, schwarze
Straußenfedern auf dem Helme, kommt, ein großes Gefolge hinter
sich. Zwei schwarze Fahnen werden hinter ihm dreingetragen. Mit
Geyers Eintritt schweigt der Gesang in der Kirche, die Glocken
schweigen, und in der Kapitelstube wird es plötzlich totenstill.
Konrad von Hanstein ist an Geyers Seite eingetreten.</p>
<p class="calibre1"><span class="speaker">Florian Geyer</span>, <span class="regie">zu Hanstein</span>. Das alte Kaiserrecht bestätigt es uns.
Die Gemeinfreien haben Konföderationsrecht. Wir sind freie Franken,
und überdas: haben die Fürsten nit die Kreiseinung, haben sie nit
den Bund zu Regensburg gestiftet wider die evangelische Lehre?
Einung wider Einung! <a class="pcalibre pcalibre1 pcalibre3 pcalibre2" id="page33" title="r_a_5/lac"></a> Die Fürsten wollen's nit gelten lassen; das machen
die verfluchten Barettlinsleut und römischen Juristen. Ich glaube,
daß kein Tyrann jemalen hat so viel Schaden gestift't als
Justinian. Das fremde, ausländische Recht ist über uns kommen
gleich einer Sintfluß. Ich lobe mir unser deutsches Herkommen, die
freien Ringe statt der Amtsstuben.</p>
<p class="calibre1"><span class="speaker">Rektor Besenmeyer</span>, <span class="regie">ergriffen und ehrfurchtsvoll.</span> Kennet Ihr mich noch,
Bruder Geyer?</p>
<p class="calibre1"><span class="speaker">Florian Geyer</span>. Potz Zäpfel, Euch
sollt ich nit kennen, Rektor Besenmeyer? Hab ich nit gemustert in
Eurer Landwehr? Haben wir nit in Philipp Tuchscheerers Haus zu
Rothenburg die Beine unter den gleichen Tisch gestellet? Was macht
der Karlstatt?</p>
<p class="calibre1"><span class="speaker">Rektor Besenmeyer</span>. Er will je eher,
je lieber zu Euch ins Läger kommen.</p>
<p class="calibre1"><span class="speaker">Florian Geyer</span>. Das verhüte Gott!
Ihr wollt ihm wohl und der Sachen wohl, so machet, daß er von
seinem Vorsatz absteht. Wir haben Prädikanten meh dann zu viel in
den Lägern. Die Glaubenssachen und himmlischen Dinge soll man
einstweilen dahinten lassen, keine Theologie in Kriegshandwerk
mengen und sich der irdischen Dinge allein befleißen.</p>
<p class="calibre1"><span class="speaker">Bubenleben</span>, <span class="regie">zu
Kohl.</span> Ei, was eine bübische, höllische Weisheit! Er hat,
St. Velten, den Schulsack gefressen.</p>
<p class="calibre1"><span class="speaker">Kohl</span>. Sehet den Rektor an, wie er
gramanzet und ihm die Hand küsset.</p>
<p class="calibre1"><span class="speaker">Bubenleben</span>. Lieber, ich kenne den
stinkigen Bacchanten allzuwohl. Sein Gott ist der Aristoteles; der
Cicero, Vergil und Livius seine Heiligen. Eine gute Latinität gilt
ihm meh denn das ganze Christentum.</p>
<p class="stage">Besenmeyer hat, von Rührung übermannt, Geyers Hand
geküßt.</p>
<p class="calibre1"><span class="speaker">Florian Geyer</span>. Was machet Ihr doch,
lieber Vater! Das will ich Euch tun. Ich bin ein grober und
ungelehrter Kopf. Und hat doch selbst der herrliche,
durchlauchtigste Kaiser Max gesagt: die Gelehrten seien es, die da
regieren und nit untertan sein sollten und denen man die meiste
Ehre schuldig war, weil Gott und die Natur sie uns anderen
vorgezogen.</p>
<p class="calibre1"><span class="speaker">Rektor Besenmeyer</span>. Lasset es zu,
Bruder! Es tut meiner armen Seele wohl. Denket Ihr noch daran, wie
wir miteinander das Symposion hatten, damalen, zu Gotha, bei dem
Mutian? Ihr hattet den Ulrich von Hutten zur Rechten <a class="pcalibre pcalibre1 pcalibre3 pcalibre2" id="page34" title="joe_ebc/lac"></a> und mich zur Linken sitzen.
Der Eitelfritz von Zollern saß uns gegenüber.</p>
<p class="calibre1"><span class="speaker">Florian Geyer</span>. Ich weiß es
wohl.</p>
<p class="calibre1"><span class="speaker">Rektor Besenmeyer</span>, <span class="regie">mit verhaltener Begeisterung.</span> Wißt Ihr auch wohl,
wie Ihr dazumalen aufstundet, den Kranz aus dem Haar nahmet und
ausriefet: »Es ist zu früh, sich mit Rosen bekränzen, dieweil noch
der Antichrist zu Rom sich mästet von unserm Mark, der deutsche
Kaiser nach Brot betteln muß, das Recht um Geld feil ist, der Ewige
Landfriede auf dem Papier stehet und das Evangelium unterdrücket
ist.« Wo stunden wir damalen, und wo stehen wir itzt?!</p>
<p class="calibre1"><span class="speaker">Geyer</span>, <span class="regie">froh.</span> Die Glocke ist gar gegossen, und der Pfeifer
mag aufpfeifen: das wollen wir Gott im Himmel danken!</p>
<p class="calibre1"><span class="speaker">Martin</span>, <span class="regie">begeistert.</span> Das danken wir Gott und dem Florian
Geyer.</p>
<p class="stage">Geyer nimmt am oberen Ende des Tisches Platz;
hinter ihm stellen sich auf Tellermann und der Schultheiß, rechts
neben ihn setzt sich Hippler, links Löffelholz, hinter diesem steht
Martin, gewärtig seines Winkes. Hippler rückt für Sartorius neben
sich einen Stuhl zurecht. Sartorius setzt sich mit vielen demütigen
Reverenzen. Hanstein ist mit Grumbach und Menzingen ins Gespräch
gekommen.</p>
<p class="calibre1"><span class="speaker">Löffelholz</span>, <span class="regie">aufstehend.</span> Brüder, Hauptleute und Räte! Nehmet
Platz! Es ist vieles zu bewegen, beraten und zu beschließen. Nehmet
Platz, liebe evangelische Brüder! Nehmet Platz!</p>
<p class="stage">Götz von Berlichingen setzt sich zugleich mit
Georg von Wertheim, dem Grafen von Henneberg, Georg Metzler und
anderen nieder. Herolde blasen eine Fanfare.</p>
<p class="calibre1"><span class="speaker">Geyer</span>, <span class="regie">nach
Schluß der Fanfare sich erhebend.</span> Der Versammlungsrat aller
Haufen gemeiner Bauernschaft in und um Würzburg ist hiemit
eröffnet.</p>
<p class="calibre1"><span class="speaker">Löffelholz</span>. Fast viel Arbeit,
Brüder! Viel zu bewegen und beschließen. Es sind Boten und Posten
herein von Hohenlohe, Nürnberg, aus vielen Orten der Oberpfalz, von
Bamberg, von Mainz, von Straßburg; aus dem Läger des Truchsessen
von Waldburg haben wir Kundschaft, aus dem Elsaß, aus dem Tirol,
aus dem Salzburgischen, von Thomas Münzer aus Thüringen und anderen
Leuten und Orten meh. Erheischet alles ein Antwort. Es mangelt an
Schreibern in der Kanzlei, hab aber dannoch niemalen meh Freud an
der <a class="pcalibre pcalibre1 pcalibre3 pcalibre2" id="page35" title="joe_ebc/lac"></a> Feder
gehabt. Der Markgraf Kasimir hat Boten von Ansbach gesandt, und hie
ist die Kredenz – warten in der Sakristei. Rothenburg ob der Tauber
hat eine Legation abgefertigt – wartet in der Sakristei.
Beschließlich erheischet die Gesandtschaft ein Bescheid, die der
Markgraf Dompropst von Unserer Frauen Berg gütlicher Handlung
willen an die Versammlung gemeiner Bauernschaft abgeordnet – wartet
in der Sakristei. Es ist meine Meinung, Brüder, daß wir uns diese
zuerst anliegen lassen.</p>
<p class="calibre1"><span class="speaker">Flammenbecker</span>, <span class="regie">unwirsch hingeflegelt.</span> Man soll auf nichts eingehen,
die Besatzung übergebe dann das Schloß mit allem, was darin
ist.</p>
<p class="calibre1"><span class="speaker">Bubenleben</span>, <span class="regie">beiläufig.</span> Ich sag ja und amen dazu, und mag die
Besatzung abziehen unter Versicherung Leibes und Lebens.</p>
<p class="calibre1"><span class="speaker">Götz</span>, <span class="regie">halb für
sich, halb für die andern.</span> Was will man meh, dann wozu sich
die Besatzung uf Unserer Frauen Berg gütlich erboten hat? Sie
wollen die Zwölf Artikel annehmen mit handgebenden Treuen und
unsere evangelischen Brüder sein.</p>
<p class="calibre1"><span class="speaker">Flammenbecker</span>. Faule Possen, potz
Lung!</p>
<p class="calibre1"><span class="speaker">Bubenleben</span>. Eine Krähe hacket der
andern die Augen nit aus. Man soll keinem Ritter in dieser Sache
trauen.</p>
<p class="calibre1"><span class="speaker">Link</span>. Ein Grindiger krauet den
andern gar sanft. Der Bruder Berlinger hat gute Gesellen und Freund
in der Burg, da liegt der Hase im Pfeffer, Brüder!</p>
<p class="calibre1"><span class="speaker">Götz</span>. Man soll nit vor festen
Schlössern verliegen. Es tut not, von Statt rucken.</p>
<p class="calibre1"><span class="speaker">Bubenleben</span>. Es liegt ihm hart an,
daß wir je eher je lieber auf und wider seinen alten Feind, den
Bamberger, ziehen.</p>
<p class="calibre1"><span class="speaker">Geyer</span>. Der Bruder Berlinger hat
wahr, ich kann's nit unbilligen. Wollen sie in der Besatzung auf
die Artikel geloben und schwören, blau! so lasse man sich benügen.
Es mangelt uns vorhero mauerbrechend Geschütz; ohn das ist nichts
zu verrichten, der Feste nichts abzubrechen.</p>
<p class="calibre1"><span class="speaker">Link</span>. Brüder! ich bin ein
Würzburger; die Würzburger aber sind eines Kopfs: das Schloß muß
herunter. Du sagst von Geschütz, Bruder Geyer! Da steht der Bruder
von Wertheim, hat uns Geschütz zugesagt, und damit gedenken wir, ob
Gott will, schnelle Arbeit zu tun! Soll denen in der Besatzung der
Reif am Kübel dermaßen werden angezogen, daß sie wie Fische sollen
daraus springen, auf Gnad und <a class="pcalibre pcalibre1 pcalibre3 pcalibre2" id="page36" title="joe_ebc/lac"></a> Ungnad sich uns ergeben. Zöget ihr aber itzt
ungestürmter Weis gen Bamberg oder Ansbach, so haben wir
Schlimmeres zu Würzburg von den Bischöflichen zu befahren als
vordem jemalen erhört ist worden.</p>
<p class="calibre1"><span class="speaker">Hippler</span>. So laßt uns ein mehrers
machen. Wessen Meinung daruf gestellt ist, daß man uf das Erbieten
der Besatzung eingehe, der hebe die Hand. <span class="regie">Götz,
Geyer, Hippler, Tellermann, Metzler, Löffelholz, Sartorius,
Wertheim und Henneberg usw. heben die Hand. Es ist eine kleine
Minderheit.</span> Jetzunder die Gegenprob! <span class="regie">Die
große Mehrheit erhebt die Hände.</span></p>
<p class="stage">Sartorius, durch Hippler veranlaßt, steht auf,
begibt sich hinaus und kehrt mit der Gesandtschaft wieder:
Sebastian von Rotenhahn, Wolf von Kastell, Hans von Lichtenstein,
Kunz von der Mühlen treten ein. Es wird still, die Bauernhauptleute
flegeln sich herum und gebärden sich hochfahrend und verächtlich
nach Möglichkeit.</p>
<p class="calibre1"><span class="speaker">Hippler</span>, <span class="regie">sitzend zu der stehenden Gesandtschaft.</span> Der
Versammlungsrat gemeiner Bauernschaft stellt an euch das Verlangen,
das Schloß Unsrer Frauen Berg und alle darin begriffene feste und
fahrende Hab zu übergeben, gegen Versicherung für euch, eure Diener
und Knecht, mit Geleit hinwegzuziehen.</p>
<p class="calibre1"><span class="speaker">Sebastian von Rotenhahn</span>,
<span class="regie">nach einigem Nachdenken.</span> Das zuzusagen
haben wir keine Vollmacht. Aber wir wollen geloben, euer Erfordern
bei eilender Post unserem gnädigen Herrn und Bischof in sein
Gewahrsam zu überschicken.</p>
<p class="calibre1"><span class="speaker">Link</span>. So sperret man uns die Mäuler
uf mit Tagsatzen, Gesandtschaften hin und wider reisen und allen
verfluchten, welschen, hinterhältigen Praktiken, und zielen auf
nichts, dann daß sie uns ufhalten und Zeit und Weile zum Widerstand
gewinnen. Man wird euch den Ernst merken lassen und euch den Ave
Maria mit Stückkugeln in die Burg schicken!</p>
<p class="calibre1"><span class="speaker">Götz</span>. Ist die Bauernschaft willens,
hie zu Würzburg ein so grausam und gottverflucht Stücklein zu
spielen, als es jüngst zu Weinsberg zu unwiederbringlicher Schmach
und Schaden gemeinen bäurischen Handels beschehen ist, so hab ich
nichts mit gemein. <span class="regie">Aufregung.</span></p>
<p class="calibre1"><span class="speaker">Bubenleben</span>. Ich frage euch hie,
Bruder Götz, und dich, Bruder Metzler: hat der Markgraf Dompropst
euch Geld geboten für den Abzug oder nit? – Gehet rund durch mit
<a class="pcalibre pcalibre1 pcalibre3 pcalibre2" id="page37" title="joe_ebc/lac"></a> der Antwort!
– – Es ist Sag: die Besatzung hätt sich wollen allein euch
zugeloben, und sollte dafür den Hauptleuten des Haufens dreitausend
Gulden Schätzung gezahlt und jedem Knecht ein halber Monatssold
zugestellt werden.</p>
<p class="calibre1"><span class="speaker">Götz</span>. Hauptleut und Rät des
Odenwälder Heers sind nit gehalten, ichtwem Red und Antwort zu
stehen als ganzer Gemeine des eigenen Haufs! <span class="regie">Aufregung.</span></p>
<p class="calibre1"><span class="speaker">Link</span>. Pfei der Schand!</p>
<p class="calibre1"><span class="speaker">Flammenbecker</span>. Verdammter Finanzer!
Nieder mit ihm!</p>
<p class="calibre1"><span class="speaker">Link</span>. Auf den Schindacker mit dem
Götz!</p>
<p class="calibre1"><span class="speaker">Geyer</span> <span class="regie">springt
auf.</span> Brüder, sind wir Leute, die Händel uf Gewinn treiben,
oder haben wir zusammen geschworen, dem Evangelium und Gottes Wort
beiständig zu sein? Sind wir Gutgewinner und Beutelschneider oder
freie deutsche Männer und Christenleut, die ihr Vornehmen daruf
gericht't haben, daß Fried, Freiheit, Einigkeit, Sicherheit Handels
und Wandels in deutscher Nation anhebe und aufrecht bleibe? –
<span class="regie">Zur Gesandtschaft.</span> Der Markgraf
Dompropst bietet Geld für den Abzug. Will er uns die Ehre abkaufen?
Ihr Herren, auf! und bringet ihm diesen Bescheid: der Papst
verschachert Christum, die deutschen Fürsten verschachern die
deutsche Kaiserkrone, aber die deutschen Bauern verschachern die
evangelische Freiheit nit! <span class="regie">Zustimmung.</span></p>
<p class="calibre1"><span class="speaker">Sebastian von Rotenhahn</span>. Die
evangelische Freiheit hat bessere Diener, als Ihr einer seid.</p>
<p class="calibre1"><span class="speaker">Geyer</span>. Das gebe Gott, und das wolle
Gott! Ihr aber seid ganz verrömert und Pfaffenknecht. Der Ulrich
von Hutten war ein besserer als ich; er hat Euch die Trias Romana
gewidmet, Ihr wart's nit wert.</p>
<p class="calibre1"><span class="speaker">Sebastian von Rotenhahn</span>. Ich setze
mich nit wider Kaiser und Reich.</p>
<p class="calibre1"><span class="speaker">Geyer</span>. Wir tun es auch nit,
niemalen und in keinem Weg. Unser Fürnehmen stehet allein darauf,
dem Kaiser seine alte Macht wiederzugeben, unverkümmert von Pfaffen
und Fürsten. Ihr setzet euch wider den Kaiser, die ihr Pfaffen und
Fürsten beiständig seid. Was hat doch der edle Kaiser Max gesagt:
Pfaffen und Fürsten hätten ihn zu Worms gebunden und an einen Nagel
gehenket. Taten von Pfaffen und Fürsten für Kaiser und Reich?
Trauben von den Disteln. Wenn der Kaiser die Läufte verstünd: hie
sind seine Bundsgenossen. <a class="pcalibre pcalibre1 pcalibre3 pcalibre2" id="page38" title="joe_ebc/lac"></a></p>
<p class="calibre1"><span class="speaker">Sebastian von Rotenhahn</span>. Kotz Blut!
Was eine Schmachbürden richtet Ihr Euch zu, Ihr, ehmals ein
ehrlicher Ritter von Adel.</p>
<p class="calibre1"><span class="speaker">Geyer</span>, <span class="regie">den Helm
abnehmend und seinen geschorenen Kopf zeigend.</span> Ein Bauer bin
ich und nichts dann ein Bauer!</p>
<p class="calibre1"><span class="speaker">Sebastian von Rotenhahn</span>. Bei meinen
adligen Ehren . . .</p>
<p class="calibre1"><span class="speaker">Geyer</span>. Zentauren seid ihr, aber
keine Adelsleut. Wo waren doch eure adligen Ehren, als es dem edlen
Franziskus von Sickingen, höchstem Vorbild aller adligen Tugenden,
die Schanze verschlug wider den Pfaffen von Trier? Damalen sollt
sich ein Edelmannskrieg anfahen. Wo blieb euer Beistand, da es not
tat? In einen alten Harnischkasten haben sie des Sickingen edlen
Leichnam gestopft, Köche und Spielleut haben ihn am Strick über den
Berg heruntergeschleift. Wo waren da eure adligen Ehren? Euer Nam
und Ehre: eine Handvoll Wind, von Pfaffen und Fürsten in Luft
geblasen.</p>
<p class="stage">Die Gesandtschaft hat sich zurückgezogen.</p>
<p class="calibre1"><span class="speaker">Wolf von Kastell</span>, <span class="regie">in der Tür, schreit zurück.</span> Ihr Männer, hütet euch
vor dem Geyer! Er ist des Franzosen heimlicher Diener, er liefert
euch dem Franzosen aus! <span class="regie">Ab mit der
Gesandtschaft.</span></p>
<p class="calibre1"><span class="speaker">Tellermann</span>. Soll ich mich an sie
machen, Kapitän?</p>
<p class="calibre1"><span class="speaker">Geyer</span>. Gemach, Bruder, es ist Pech
und Schwefel genung über meine Rüstung gelaufen. Hab gut Sorg, daß
ihnen strack sicheres Geleit gehalten werd bis in ihr
Gewahrsam.</p>
<p class="calibre1"><span class="speaker">Trabant</span> <span class="regie">kommt,
meldet.</span> Kapitän, haben sich viel hundert Weiber rottieret
und dieshalb wie jenhalb der Mainbrücken ufgestellt. Sind in
willens, die Gesandtschaft beim Widerritt ufzuhalten, schwören, sie
wollten's nit wieder in die Burg lassen, und sollt sie der Teufel
nit daran hindern, vielmeh alles, was pfäffisch sei, von den
Kleppern reißen und in den Main stürzen.</p>
<p class="calibre1"><span class="speaker">Geyer</span>. Blitz und Donner, was haben
wir doch mit Weiberröcken zu schaffen! Frisch, Galgen ufgericht't!
Den Profossen in sie arbeiten lassen, flugs aufknüpfen, was nit
guttun will!</p>
<p class="calibre1"><span class="speaker">Flammenbecker</span>. Hast Stock und
Galgen auch nit von kaiserlicher Majestät erworben.</p>
<p class="stage">Trabant ab.</p>
<p class="calibre1"><span class="speaker">Link</span>. Brüder, itzt ist eine Stunde
warten zu lang. Nu frisch daran! Mit ganzer bäurischer Macht und
Geschütz, mit <a class="pcalibre pcalibre1 pcalibre3 pcalibre2" id="page39" title="joe_ebc/lac"></a>
Sturmbock, Tartsche und Leiter sei wider das Schloß gehandelt!
Dran! Dran! mit Gewalt und Gotteskraft, daß sie den grimmen Ernst
wohl vermerken und Rittern und Knechten in der Besatzung blutbange
werd. Platzet sie an mit dem Geschütz . . .</p>
<p class="calibre1"><span class="speaker">Löffelholz</span>. Mit was Geschütz soll
man sie anplatzen? – Höret mir zu, liebe Brüder! Eins tut itzt vor
allem not, und so ihr derselben Meinung seid und Gott euch
erleuchtet, so gibt er euch noch diese Stunde den Wurf in die Hand.
Ich denke wohl, daß ihr mich genugsam kennt. Ich habe die
evangelische Freiheit alleweil liebgehabt von ganzem Gemüt. Die
Handvoll Bluts in meim Busen innen, die will ich getrost an den
Handel setzen.</p>
<p class="leftmarg">Gott hat uns bis hieher glücklich und wohl
geführet. Alle großen Köpfe und gewaltigen Hansen ducken sich und
haben die Flucht geben. Dannoch will mir das Herz nit so fast groß
werden und lustig. Bös Ahnen nestelt sich an mich, ob ich nit weiß,
warum.</p>
<p class="leftmarg">Brüder, ein oberster Wille muß sein! Wir müssen
ein Haupt über uns setzen, einen gewaltig machen über alle Haufen
der Bauernschaft. Das uneine Gespann stürzet den Pflug um. Ein
Wille ist oft meh denn tausend, eine Hand oft meh denn hundert, und
dieweil ihr dreimal des Tages ein mehrers macht, kehrt sich der
Pövel im hellen Haufen mitnichten daran und macht alle Ordnung und
Artikel zu einem Spott, Schmach und Gelächter.</p>
<p class="leftmarg">Der Truchseß von Waldburg steht mit des
Schwäbischen Bundes Heer in Rüstung wider uns. Dawider ist hoch
vonnöten, daß wir in Zeiten uns schicken. Da ist ein einiger Mann
und einiger, fester Will Reitergeschwader und Fußknecht, ein
strack, scharf Regiment ein gewaltiger Kriegshauf, gedient und
erfahren im Feld. So ist mein Fürschlag und Meinung, daß man den
Florian Geyer erwählen und kiesen soll mit Bestallung gemeiner
Bauernschaft, sei es uf ein Jahr. Man soll ihm Räte beigeben . . .
<span class="regie">Unruhe.</span></p>
<p class="calibre1"><span class="speaker">Metzler</span>. Der Götz von Berlichingen
soll unser Hauptmann sein!</p>
<p class="calibre1"><span class="speaker">Bubenleben</span> <span class="regie">springt auf.</span> Brüder, man soll keinen Edelmann über
uns setzen! Art läßt nit von Art. Ein Habicht wird niemals zur
Taube, und ein Rittermäßiger wird nie zu einem evangelischen Bauern
werden! Es sollt überhaupt kein Ritter in diesem Rat sitzen! <a class="pcalibre pcalibre1 pcalibre3 pcalibre2" id="page40" title="malosept/lac"></a></p>
<p class="calibre1"><span class="speaker">Tellermann</span> <span class="regie">ist
wiedergekehrt, schreit dazwischen.</span> Es sollte kein Pfaff in
unserem Rat sitzen!</p>
<p class="calibre1"><span class="speaker">Bubenleben</span>. Ei nun, es ist
landkundig, daß ihr Geyerschen nit viel haltet von Gottes Wort.
Nimmt mich auch nit wunder, kämpft ihr doch unter der schwarzen
Fahn! Habt ihr doch in der gottlosen Bande noire gedient, wo nichts
dann Ächter, Gotteslästerer und Heiden innen sind. Ihr wollet Gott
absetzen, wir aber wollen ihn einsetzen und ihm allein dienen. So
wird Gott uns auch einen Helden erwecken, wann das Stündlein
schlägt . . .</p>
<p class="calibre1"><span class="speaker">Löffelholz</span>, <span class="regie">zwischenrufend.</span> Und wann er schon unter euch sitzet,
so sehet ihr ihn doch nit.</p>
<p class="calibre1"><span class="speaker">Bubenleben</span>, <span class="regie">fanatisch.</span> Gott wird einen Helden ausrüsten, dem
großen Werke gewachsen. Der wird die Moab, Agag, Achab, Phalaris
und Neros dieser Zeit von den Stühlen stoßen und ihnen die
Bluttaufe geben. Gemeiner Leute Kind wird er sein und keiner von
den Rittern, die, ob sie gleich in Eisen gepanzert sind, so leise
und fürsichtig gehen wie die Katzen auf dem Dachfirst. Sie schonen
der Ihren allerwegen; verflucht aber ist jeder Gläubige, der sein
Schwert vom Blute der Widersacher Christi fernhält. Itzt heißt es
die Hände baden in ihrem Blut und darin heiligen.</p>
<p class="calibre1"><span class="speaker">Der Schultheiß</span>. Der Pfaff ist
besessen.</p>
<p class="calibre1"><span class="speaker">Bubenleben</span>. Wollt ihr jetzt einen
zum Obersten Hauptmann machen, so erwählet . . .</p>
<p class="calibre1"><span class="speaker">Der Schultheiß</span>, <span class="regie">schnell.</span> . . . den Bruder Bubenleben, Pfarrer zu
Mergentheim! <span class="regie">Gelächter.</span></p>
<p class="calibre1"><span class="speaker">Bubenleben</span>. Nein, nit mich, aber
den Mann, welchen der fränkische Hauf über sich gesetzet: den Jacob
Kohl von Eifelstadt.</p>
<p class="calibre1"><span class="speaker">Löffelholz</span>, <span class="regie">zwischenrufend.</span> Er kann alle großen Schwür.</p>
<p class="calibre1"><span class="speaker">Tellermann</span>. So feist er ist,
baumelt er dannoch dem Pfaffen am Gürtel.</p>
<p class="calibre1"><span class="speaker">Geyer</span> <span class="regie">steht
auf.</span> Wer will halten rein sein Haus, der behalt Pfaffen und
Mönche draus.</p>
<p class="stage">Geyers entschlossene Bewegung erregt Aufsehen in
der Versammlung. Man beobachtet ihn in der Folge scharf. Er spricht
intim mit Tellermann, dem Schultheiß und Löffelholz. Hippler und
Götz flüstern und beobachten ebenfalls. Der Schultheiß und
Tellermann gestikulieren immer heftiger auf Geyer ein.</p>
<p class="calibre1"><span class="speaker">Kohl</span>. Brüder, wann das
Löffelhölzlein auch schellig wird, das <a class="pcalibre pcalibre1 pcalibre3 pcalibre2" id="page41" title="Teledahner/gary"></a> schiert mich in keinem Weg. Meine
bäurischen Brüder kennen mich.</p>
<p class="calibre1"><span class="speaker">Martin</span>, <span class="regie">zwischenrufend</span>. Aus der Trinkstuben!</p>
<p class="calibre1"><span class="speaker">Kohl</span>. Potz! Daß dich das Wetter
erschlag! Soll ich es leugnen, daß mir der Wein ebenso
wohlschmecket als einem Ritter? Der Teufel sollt mir die Lüg
gesegnen. Meinst du, man soll nit in der Trinkstuben sitzen,
sundern allweg hoch und uf Stelzen einhertreten, sich meh bedünken
als andere bäurische Brüder im hellen Haufen? Soll man sich alleweg
aufblasen, wie die Geyerschen tun? »He da! Tretet aus dem Weg,
daher fahr <i class="calibre4">ich!</i>« Das tu ich nit. Um mich ist alles
glaslauter.</p>
<p class="calibre1"><span class="speaker">Martin</span>, <span class="regie">zwischenrufend</span>. Lauter Gläser und Kannen!
<span class="regie">Gelächter.</span></p>
<p class="calibre1"><span class="speaker">Kohl</span>. Jawohl, glaslauter ist alles
um mich.</p>
<p class="calibre1"><span class="speaker">Zwischenruf</span>. Würzburger
Jüdenwein!</p>
<p class="calibre1"><span class="speaker">Kohl</span>. Nit Würzburger Jüdenwein,
sundern es ist glaslauter um mich. Ich halt mich nach meinem
Schwur, und so mir vom ganzen hellen Haufen ufgelegt wird: tue das!
so tu ich's, und: laß deine Hand von dem andern! so laß ich meine
Hand davon. Heimliche Praktiken und verräterische Anschläg treib
ich nit. Wählet man mich, so wählet man mich; wählet man mich nit,
so wollt ich doch lieber am Galgen verfaulen, sollt mir der
Schinder das Herz aus dem Leibe brennen, eh daß ich mich des
tyrannischen Gewalts unterstünd.</p>
<p class="calibre1"><span class="speaker">Löffelholz</span>. Wer unterstehet sich
hie des Gewalts?</p>
<p class="calibre1"><span class="speaker">Kohl</span>. Das, Bruder, fraget den
Florian Geyer!</p>
<p class="calibre1"><span class="speaker">Flammenbecker</span>. Brüder, wir brauchen
keinen Hauptmann über uns alle. Stoßen wir deshalb die kleinen
Tyrannen von den Stühlen, damit wir die großen daruf setzen? Es
gibt hie Leute unter uns, die mögen ihre herrischen und teuflischen
Gelüsten nit unterdrucken. Sie setzen Profossen über uns,
Stockmeister und Schergen. Sie meinen uns mit Steckenknechten zu
regnieren, schlimmer und grausamer, dann es unter dem Papsttum
gewest. Sie haben hie zu Würzburg Galgen ufgericht't.</p>
<p class="calibre1"><span class="speaker">Geyer</span> <span class="regie">schreit
dazwischen</span>. Noch meh Galgen, und alle Weinsberger Blutbuben
daran gehenket!</p>
<p class="calibre1"><span class="speaker">Flammenbecker</span>, <span class="regie">rasend</span>. Alle Junker, Gutgewinner und Ächter daran
gehenket! Zum Teufel mit allen gelben Sporen! Man muß euch durch
die Spieße jagen wie den <a class="pcalibre pcalibre1 pcalibre3 pcalibre2" id="page42" title="elbinger/gary"></a> Helfensteiner, euch vierteilen als die
verfluchten Verräter und Bösewicht! <span class="regie">Gelächter
der Ritter.</span></p>
<p class="calibre1"><span class="speaker">Hippler</span>. Bruder Geyer, stehet mir
Red und Antwort. Es geht das Geschrei, die Euren hätten Gemein
gehalten, Hauptleute, Obriste und Feldweibel des schwarzen Haufs
hätten es in sie getrieben und jedermann persuadieret
meuterischerweis, und sei auch beschlossen worden im Ring: sie
wollten in keinem Weg einen andern dulden, man setze dann Euch,
Bruder Geyer, zum Obristen-Feldhauptmann über alle Haufen.</p>
<p class="calibre1"><span class="speaker">Geyer</span>. Da weiß ich nichts von, was
gehet mich das an!</p>
<p class="calibre1"><span class="speaker">Götz</span>. Brüder, was sollen uns die
Trabanten vor der Kirchenporten? Schicket sie doch heim.</p>
<p class="calibre1"><span class="speaker">Link</span>. Wem stehen sie zu?</p>
<p class="calibre1"><span class="speaker">Flammenbecker</span>. Sind vom schwarzen
Häuf, stehen dem Florian Geyer zu.</p>
<p class="calibre1"><span class="speaker">Bubenleben</span>. Brüder, was will das
werden? Nit weit von hie, uf der Gassen, bin ich auf ein stark
Fähnlein gewappneter Knecht gestoßen.</p>
<p class="calibre1"><span class="speaker">Löffelholz</span>. Sind für das
Barfüßer-Kloster bestimmt, sollen Quartier darin nehmen um Friedens
und Ordnung willen, damit es nit hie zu Würzburg mit Plündern,
Stehlen und Beschädigung Leibes und Gutes also türkisch zugehe wie
anderwärts.</p>
<p class="calibre1"><span class="speaker">Link</span>. Die Bürgerschaft hat ein gut
Fähnlein aus allen Vierteilen ausmustern lassen und in das
Barfüßer-Kloster gelegt. So werden wir selbst wissen Ordnung und
Fried aufrechterhalten.</p>
<p class="calibre1"><span class="speaker">Der Schultheiß</span>. Ei, Link, das
Fähnlein im Barfüßer-Kloster tuet es allen voran mit Schatzen,
Ranzionen und durch die Häuser laufen! Und wär es nit so, unter
allen Haufen der Bauern sind unnütze Leut genung. Jaufkinder,
Luderer und anderes Gesindel webert ein und aus durch die Tore.
Dawider ist gut, daß man ihnen ihr eigen Regiment zeige und
Bäurische wider Bäurische ufbiete.</p>
<p class="calibre1"><span class="speaker">Link</span>. Wird einer Bürgerschaft hie
zu Würzburg nit wohl eingehen.</p>
<p class="calibre1"><span class="speaker">Flammenbecker</span>. Es seien kein
unnütze Leut im hellen Haufen!</p>
<p class="calibre1"><span class="speaker">Geyer</span>. Es gehe der Bürgerschaft
wohl oder übel ein, es tut not, daß wir beizeiten anfahen, Ordnung
und Zucht in die Haufen zu treiben. Lassen wir den Teufel fürder
gewähren <a class="pcalibre pcalibre1 pcalibre3 pcalibre2" id="page43" title="elbinger/gary"></a>
mit Verwüstung Proviants, Getreid in den Main schütten, Wein aus
den Fässern lassen laufen, wahrlich, meiner Seel, es wird bald
dahin kommen, daß ein evangelischer Bruder im hellen Haufen wird
müssen mit blutigen Fingern nach einem Stück Hungerbrot graben!</p>
<p class="calibre1"><span class="speaker">Götz</span>. Was hab ich gesagt, Brüder?
Stoßen die Geyerschen zu uns, so fahet sich Zwietracht an und nimmt
niemalen kein Ende meh.</p>
<p class="calibre1"><span class="speaker">Geyer</span>. Bruder Berlinger, wer hat
meh Zwietracht gesäet in die Haufen, ich oder Ihr?</p>
<p class="calibre1"><span class="speaker">Götz</span>. Ein jeder beuget und bücket
sich, allein die Geyerschen bleiben auf ihrem Kopf, kümmern sich um
den gemeinen Handel nit.</p>
<p class="calibre1"><span class="speaker">Tellermann</span>. Kotz Schweiß, Bruder
Berlinger, habt ihr wohl unsrer geachtet, saget mir doch, als ihr,
du und der Metzler, euren Zug nähmet, wo wir und der schwarze Hauf
vordem gezogen? Neun Städte uf'm Odenwald haben sich uns ufgetan
und zugelobt. Hat es der Florian Geyer durchgesetzt, ward von den
Unseren keinem Bürger ein Fensterlein zerworfen, keiner Magd ein
Fürfleck verrückt. Aber hernacher seid ihr kommen, alles
gebrandschatzt, über Kisten und Keller gefallen, Weiber geschändet,
viel hundert Wägen Plunders fort lassen schleppen. Bruder, als das
ist ruchbar worden in ganzer Gemeine des schwarzen Haufs, was
Wunders, daß ihnen die Wut ist ankommen. So habt <i class="calibre4">ihr</i>
Zwietracht unter die Brüder gesäet! Die Städte, mit Eiden und
Pflichten uns verstrickt, ihr habt gemacht, daß sie mußten Eide und
Pflichten brechen und euch wiederum zugeloben.</p>
<p class="calibre1"><span class="speaker">Götz</span>. Sollte man euch lassen
gewähren, ihr Geyerschen, der teuren evangelischen Freiheit
erstünden meh Feinde über Nacht, dann es Krämer gibt in Venedig,
Säufer in Sachsen, Säue in Pommern und Huren in Bamberg
insgesamt.</p>
<p class="calibre1"><span class="speaker">Geyer</span>. Wißt Ihr noch meh, Bruder
Berlinger?</p>
<p class="calibre1"><span class="speaker">Götz</span>. Ihr habt uns den ganzen Adel
feind gemacht.</p>
<p class="calibre1"><span class="speaker">Geyer</span>. Ich hab den Artikelbrief
vollstreckt.</p>
<p class="calibre1"><span class="speaker">Götz</span>. Es tut dannoch nit not. Ihr
seid selber vordem ein Ritter gewest. Ist es nit schmählich,
Bruder, daß Ihr es allen vorantut mit Zerreißung fester Schlösser
und Häuser des Adels, da Ihr doch jedem Pfeffersack Reverenz
machet, wenn er gleich nur mit der Zipfelhauben über die Stadtmauer
herausdräuet? Die Häuser des Adels . . . <a class="pcalibre pcalibre1 pcalibre3 pcalibre2" id="page44" title="MEsswein/gary"></a></p>
<p class="calibre1"><span class="speaker">Geyer</span>. Herunter mit ihnen, herunter
mit allen verfluchten Rabennestern! Es muß ein Ende nehmen mit
Heckenschinden und Staudenreiten. Meine weiland guten Gesellen vom
Adel sollen lernen Besseres tun dann zwo Beine über ein Roß henken,
Händel uf Gewinn treiben, Bauern schinden und schatzen, Kaufleut
niederwerfen, verstricken oder in die stinkigen Türme werfen, ihnen
Händ abhacken, Ohren abschneiden und dergleichen ritterlicher
Handlungen meh. Ihr sollt fortan eine Tür haben, den Acker bauen
und zu Fuß gehen wie andre Christenleut. Der Edelmann ist nit
meh . . .</p>
<p class="calibre1"><span class="speaker">Götz</span>. Wie denkst du über des
Edelmanns Wort, Bruder?</p>
<p class="calibre1"><span class="speaker">Geyer</span>. Wie über jedermanns Wort,
daß ein Wort ein Wort bleibe.</p>
<p class="calibre1"><span class="speaker">Götz</span>. Denk an Möckmühlen, als du
noch bestallter Hauptmann des Schwäbischen Bundes warst! Welche
bündischen Hundsfötter haben mir damals Geleit zugesagt und
gebrochen?</p>
<p class="calibre1"><span class="speaker">Geyer</span>. Nimm einen Löffel und friß
deine Lüge!</p>
<p class="calibre1"><span class="speaker">Hippler</span> <span class="regie">erhebt
sich</span>. Friede, ihr Brüder! – <span class="regie">Man hört
schießen.</span> Kotz, was ist das?</p>
<p class="calibre1"><span class="speaker">Götz</span>. Oha! Büberei!</p>
<p class="calibre1"><span class="speaker">Geschrei</span>, <span class="regie">tumultuarisch</span>. Büberei! Verrat!</p>
<p class="calibre1"><span class="speaker">Massenruf von außen</span>. Vivat Florian
Geyer!</p>
<p class="stage">Tumult und Panik in der ganzen Versammlung.</p>
<p class="calibre1"><span class="speaker">Geschrei</span>. Verrat! Meuterei!</p>
<p class="calibre1"><span class="speaker">Geyer</span> <span class="regie">springt
auf, schreit</span>: Ruhe, Brüder! Ein Hundsfott, wer von Verrat
schreit. Hie steh ich und gelob ich, daß ich Amt und Bestallung nit
anders will empfahen oder zur Hand nehmen, es sei mir denn
übergeben vom Versammlungsrat gemeiner bäurischer Brüderschaft. Und
wen sie über uns alle will mächtig machen, dem will ich mich
gehorsam beugen und untertan sein, als einem evangelischen Bauern
geziemet und zusteht. Aber meine Meinung ist, liebe Brüder, daß man
einen Kriegsrat erwähle, kundige und kriegserfahrene Leute
dareinsetze und den bewegen lasse, was gen innen und außen zu tun
und zu lassen sei. Wer aber der Meinung ist, daß das beschehe, der
stoße sein Messer in diesen Ring. <span class="regie">Er zieht mit
Kreide einen Kreis auf der Kirchentür</span>.</p>
<p class="calibre1"><span class="speaker">Tellermann</span>, <span class="regie">sein Messer zückend</span>. Dem Truchsessen von <a class="pcalibre pcalibre1 pcalibre3 pcalibre2" id="page45" title="MEsswein/gary"></a> Waldburg,
bestalltem Obersten Hauptmann des Bundes zu Schwaben, mitten ins
Herz! <span class="regie">Er stößt zu</span>.</p>
<p class="calibre1"><span class="speaker">Bubenleben</span>. Dem Bischof Konrad von
Thüringen mitten ins Herz! <span class="regie">Er stößt
zu</span>.</p>
<p class="calibre1"><span class="speaker">Flammenbecker</span>. Dem Georgen Truchseß
von Waldburg, bestalltem Obersten Hauptmann des Bundes zu Schwaben,
dem Bluthund von Wurzach, mitten ins Herz! <span class="regie">Ebenso</span>.</p>
<p class="calibre1"><span class="speaker">Ein Weinsberger</span>. Rache für Wurzach!
Rache für die siebentausend gemordeten Brüder! Dem Truchsessen von
Waldburg mitten ins Herz! <span class="regie">Ebenso</span>.</p>
<p class="calibre1"><span class="speaker">Löffelholz</span>. Allen Fuggern und
Welsern mitten ins Herz! <span class="regie">Ebenso</span>.</p>
<p class="calibre1"><span class="speaker">Sartorius</span>. Dem Truchsessen von
Waldburg mitten ins Herz! <span class="regie">Ebenso</span>.</p>
<p class="calibre1"><span class="speaker">Erster Bauernhauptmann</span>. Allen
Schindern und Schabern des Volkes mitten ins Herz! <span class="regie">Ebenso</span>.</p>
<p class="calibre1"><span class="speaker">Zweiter Bauernhauptmann</span>,
<span class="regie">zu Grumbach</span>. Flugs, Bruder, sage du auch
deinen Spruch!</p>
<p class="calibre1"><span class="speaker">Martin</span>. Allen pfäffischen Königen
und königlichen Pfaffen mitten ins Herz! <span class="regie">Ebenso</span>.</p>
<p class="calibre1"><span class="speaker">Wilhelm von Grumbach</span>. Dem Bischof
Konrad von Würzburg mitten ins Herz! <span class="regie">Ebenso</span>.</p>
<p class="calibre1"><span class="speaker">Hippler</span>. Dem Kanzler der Herzöge
von Bayern, bestalltem Rat des Bundes zu Schwaben, dem
gottverfluchten Leonhard Eck, mitten ins Herz! <span class="regie">Ebenso</span>.</p>
<p class="calibre1"><span class="speaker">Dritter Bauernhauptmann</span>. Dem
Truchsessen von Waldburg mitten ins Herz! <span class="regie">Ebenso</span>.</p>
<p class="calibre1"><span class="speaker">Geyer</span>. Der deutschen Zwietracht
mitten ins Herz! <span class="regie">Ebenso</span>. <a class="pcalibre pcalibre1 pcalibre3 pcalibre2" id="page46" title="MEsswein/gary"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0004.vue?c094d7c6